/**
 * React Query hook for fetching document preview data
 * Used for hover tooltip in chat input
 */
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";

export interface DocumentPreviewData {
    document_id: string;
    file_name: string | null;
    document_type: string | null;
    document_type_id: string | null;
    document_number: string | null;
    file_mime_type: string | null;
    file_size_bytes: number | null;
    document_date: string | null;
    container: {
        container_id: string;
        container_number: string;
        container_type: string | null;
    } | null;
    metadata: {
        total_pages: number | null;
        thumbnail_url: string | null;
    };
}

export function useDocumentPreview(documentId: string | null) {
    return useQuery({
        queryKey: ["document", "preview", documentId],
        queryFn: async (): Promise<DocumentPreviewData> => {
            if (!documentId) {
                throw new Error("Document ID is required");
            }

            return await apiGet<DocumentPreviewData>(
                `/documents/${documentId}/preview`,
                { requireAuth: true }
            );
        },
        enabled: !!documentId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes
    });
}
